<template>
  <div class="elegant-detail">
    <!-- 顶部背景 -->
    <div class="top-banner-box">
      <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }"></div>
    </div>
    <!-- 公司简介 -->
    <div class="bannerInfo">
      <div class="info-con">
        <div class="info-pic" :style="{ backgroundImage: `url(${reseult.banner})` }"></div>
        <div class="info-title">{{ reseult.title }}</div>
        <!-- <div class="info-des">{{ reseult.description }}</div> -->
        <!-- <div class="info-service">
          服务能力：
          <span v-for="(item, index) in reseult.capabilityList" :key="index">
            <span class="info-text">{{ item.title + ' ' }}</span>
          </span>
          {{ reseult.serviceAre }}
        </div>-->
        <div class="info-link">
          联系方式：
          <span>{{ reseult.linkMethod }}</span>
        </div>
      </div>
    </div>
    <div class="container">
      <div v-html="reseult.content" class="full-element"></div>
    </div>
  </div>
</template>

<script>
import { getElegantDetail, getDictionaryItem } from "../../utils/interface";
export default {
  data() {
    return {
      headerBgUrl: "",
      reseult: {}
    };
  },
  created() {
    this.getElegantDetail(this.$route.query.uuid);
    this.getOptionsData();
  },
  methods: {
    getElegantDetail(uuid) {
      getElegantDetail(uuid).then(res => {
        if (Object.keys(res.data).length) {
          this.reseult = res.data;
        } else {
          this.reseult = {};
        }
      });
    },
    getOptionsData() {
      //顶部背景图
      getDictionaryItem({
        code: "FWS_BANNER"
      }).then(res => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value;
        } else {
          this.headerBgUrl = "";
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.elegant-detail {
  position: relative;
  top: -80px;
  margin-bottom: -80px;

  .top-banner-box {
    // background-color: #f7f8fb;

    .top-banner-img {
      height: 400px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .bannerInfo {
    width: 1300px;
    margin: 0 auto;
    color: #fff;
    display: flex;
    flex-flow: row nowrap;
    justify-content: start;
    font-weight: normal;
    position: relative;
    background-color: #fff;
    color: #000;
    border-radius: 16px;
    box-shadow: 0 2px 8px 0 rgba(20, 30, 49, 0.1);
    top: -120px;
    padding: 28px 40px 40px;
    box-sizing: border-box;

    .info-pic {
      width: 120px;
      height: 70px;
      background: no-repeat center center/100% 100%;
      border-radius: 16px;
    }

    .info-con {
      margin-left: 40px;
      flex: 1;

      .info-title {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 40px;
      }

      .info-des {
        margin-top: 20px;
        font-size: 16px;
      }

      .info-service {
        margin-top: 20px;

        .info-text {
          margin: 0 5px;
          padding: 4px 10px;
          background-color: #2d50a130;
          color: #2d50a1;
          border-radius: 6px;
        }
      }

      .info-link {
        margin-top: 20px;
      }
    }
  }

  .container {
    width: 1300px;
    margin: 10px auto;
    position: relative;
    top: -105px;

    .full-element {
      width: 100%;
      margin: 0 0 20px;
      box-sizing: border-box;
      padding: 20px 40px;
      // box-shadow: 0 0 8px #99999947;
      border-radius: 16px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/innovateService/elegantDetail.vue